import { useCallback, useEffect, useState } from "react";
import utils from "utils";

const LOADING = "loading";
const READY = "ready";
const FAILED = "failed";

// A layout's first data load, run once `enabled` and again whenever a value in
// `deps` changes or the user retries. A load that throws ends in `hasFailed`,
// for the layout to show with a retry -- not in a loader that never goes away.
// The failure itself has already been reported (callAPI's alert); this only
// keeps the page usable. Only the latest load's outcome counts.
const useInitialLoad = (enabled, load, deps) => {
  const [status, setStatus] = useState(LOADING);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;

    let ignore = false;
    setStatus(LOADING);

    void (async () => {
      try {
        await load();
        if (!ignore) setStatus(READY);
      } catch (error) {
        utils.debug("error", "useInitialLoad -- first load failed", error);
        if (!ignore) setStatus(FAILED);
      }
    })();

    return () => {
      ignore = true;
    };
    // `load` is a fresh closure every render; `deps` says when it changes.
  }, [enabled, attempt, ...deps]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  return {
    isReady: status === READY,
    hasFailed: status === FAILED,
    retry,
  };
};

export default useInitialLoad;
